import { render, staticRenderFns } from "./fooddetail.vue?vue&type=template&id=45787000&scoped=true"
import script from "./fooddetail.vue?vue&type=script&lang=js"
export * from "./fooddetail.vue?vue&type=script&lang=js"
import style0 from "./fooddetail.vue?vue&type=style&index=0&id=45787000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45787000",
  null
  
)

export default component.exports